import {
    Box,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Badge,
    Button,
    Input,
    InputGroup,
    InputRightAddon,
    Flex,
    Icon,
    Text,
    TableContainer,
    VStack,
    useBreakpointValue,
} from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";
import { FiMonitor } from "react-icons/fi";
import { useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar";

const tickets = [
    { subject: "[Ticket#8205479] Interested in buying", user: "Mayank", status: "Pending", priority: "Medium", reply: "3 weeks ago" },
    { subject: "[Ticket#112233] Issue with login", user: "John Doe", status: "Closed", priority: "Low", reply: "1 week ago" },
    { subject: "[Ticket#778899] How to withdraw?", user: "Alice Walker", status: "Answered", priority: "Medium", reply: "2 days ago" },
];

const getStatusBadge = (status) => {
    switch (status) {
        case "Pending": return <Badge colorScheme="orange" variant="outline" px={3} borderRadius="full" textTransform="none">Pending</Badge>;
        case "Closed": return <Badge colorScheme="red" variant="solid" px={3} borderRadius="full" textTransform="none">Closed</Badge>;
        case "Answered": return <Badge colorScheme="green" variant="solid" px={3} borderRadius="full" textTransform="none">Answered</Badge>;
        default: return <Badge px={3} borderRadius="full" textTransform="none">{status}</Badge>;
    }
};

const getPriorityColor = (priority) => (priority === "High" ? "red" : priority === "Medium" ? "orange" : "blue");

const ITEMS_PER_PAGE = 10;

const AllTickets = () => {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");
    const isMobile = useBreakpointValue({ base: true, md: false });

    const totalPages = Math.ceil(tickets.length / ITEMS_PER_PAGE);
    const data = tickets.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE);
    const SIDEBAR_WIDTH = "240px";

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box p={{ base: 4, md: 8 }} bg="gray.50" minH="100vh" mt="64px" ml={{ base: 0, md: SIDEBAR_WIDTH }}>
                <Flex mb={8} justify="space-between" align={{ base: "stretch", md: "center" }} direction={{ base: "column", md: "row" }} gap={4}>
                    <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="semibold" color="#1a202c">All Tickets</Text>
                    <InputGroup maxW={{ base: "100%", md: "300px" }} size="md">
                        <Input bg="white" placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} borderRight="none" _focus={{ borderColor: "#4f46e5", boxShadow: "none" }} />
                        <InputRightAddon bg="#4f46e5" cursor="pointer" _hover={{ bg: "#4338ca" }}>
                            <Icon as={SearchIcon} color="white" />
                        </InputRightAddon>
                    </InputGroup>
                </Flex>

                {/* MOBILE CARD VIEW */}
                {isMobile ? (
                    <VStack spacing={4} align="stretch">
                        {data.map((t, i) => (
                            <Box
                                key={i}
                                bg="white"
                                borderRadius="12px"
                                p={4}
                                boxShadow="0 2px 4px rgba(0, 0, 0, 0.05)"
                                border="1px solid #e2e8f0"
                            >
                                <Flex justify="space-between" align="flex-start" mb={3}>
                                    <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                        Subject
                                    </Text>
                                    <Text fontSize="sm" fontWeight="600" color="#3182ce" textAlign="right">
                                        {t.subject}
                                    </Text>
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                    <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                        Submitted By
                                    </Text>
                                    <Text fontSize="sm" fontWeight="500" color="#4a5568">
                                        {t.user}
                                    </Text>
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                    <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                        Status
                                    </Text>
                                    {getStatusBadge(t.status)}
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                    <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                        Priority
                                    </Text>
                                    <Badge colorScheme={getPriorityColor(t.priority)} variant="outline" px={3} borderRadius="full" textTransform="none">
                                        {t.priority}
                                    </Badge>
                                </Flex>

                                <Flex justify="space-between" py={2} borderTop="1px solid #e2e8f0">
                                    <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                        Last Reply
                                    </Text>
                                    <Text fontSize="sm" color="gray.500">
                                        {t.reply}
                                    </Text>
                                </Flex>

                                <Flex justify="space-between" pt={2} borderTop="1px solid #e2e8f0">
                                    <Text fontSize="sm" fontWeight="700" color="#1a202c">
                                        Action
                                    </Text>
                                    <Button size="sm" variant="outline" colorScheme="blue" leftIcon={<Icon as={FiMonitor} />} fontSize="xs" px={4}>
                                        Details
                                    </Button>
                                </Flex>
                            </Box>
                        ))}
                    </VStack>
                ) : (
                    /* DESKTOP TABLE VIEW */
                    <Box bg="white" borderRadius="lg" overflow="hidden" boxShadow="sm" border="1px solid #e2e8f0">
                        <TableContainer>
                            <Table variant="simple">
                                <Thead bg="#4f46e5">
                                    <Tr h="50px">
                                        <Th color="white" textTransform="none" borderTopLeftRadius="lg">Subject</Th>
                                        <Th color="white" textTransform="none">Submitted By</Th>
                                        <Th color="white" textTransform="none" textAlign="center">Status</Th>
                                        <Th color="white" textTransform="none" textAlign="center">Priority</Th>
                                        <Th color="white" textTransform="none">Last Reply</Th>
                                        <Th color="white" textTransform="none" textAlign="right" borderTopRightRadius="lg">Action</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {data.map((t, i) => (
                                        <Tr key={i} _hover={{ bg: "gray.50" }}>
                                            <Td fontWeight="600" color="#3182ce" fontSize="sm">{t.subject}</Td>
                                            <Td fontWeight="500" fontSize="sm">{t.user}</Td>
                                            <Td textAlign="center">{getStatusBadge(t.status)}</Td>
                                            <Td textAlign="center">
                                                <Badge colorScheme={getPriorityColor(t.priority)} variant="outline" px={3} borderRadius="full" textTransform="none">{t.priority}</Badge>
                                            </Td>
                                            <Td color="gray.500" fontSize="sm">{t.reply}</Td>
                                            <Td textAlign="right">
                                                <Button size="sm" variant="outline" colorScheme="blue" leftIcon={<Icon as={FiMonitor} />} fontSize="xs">Details</Button>
                                            </Td>
                                        </Tr>
                                    ))}
                                </Tbody>
                            </Table>
                        </TableContainer>
                    </Box>
                )}
            </Box>
        </>
    );
};

export default AllTickets;
